import { ProLearningPathCard } from './pro-learning-path-card/pro-learning-path-card.react-component';
const YEAR_FROM_NOW = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
export const HOW_IT_WORKS_EXPIRATION_DATE = YEAR_FROM_NOW;
export const LIMIT_ATTEMPTS_BANNER_EXPIRATION_DATE = YEAR_FROM_NOW;
export const LEARNING_PATH_FOLDERS_PAGE_SIZE = 100;
export const LEARNING_PATH_ICON = 'learning-guide';
export const PRO_CONTENT_TYPE = Object.freeze({
  udemyPath: {
    label(gettext) {
      return gettext('Udemy path');
    },
    getComponent: () => ProLearningPathCard,
    componentObjectProp: 'proLearningPath'
  },
  lab: {
    label(gettext) {
      return gettext('Lab');
    },
    getComponent: () => undefined,
    componentObjectProp: 'proLab'
  },
  assessment: {
    label(gettext) {
      return gettext('Assessment');
    },
    getComponent: () => undefined,
    componentObjectProp: 'proAssessment'
  }
});
export const ProContentUIRegions = {
  MY_LEARNING_UNIT: 'my_learning_unit',
  RECOMMENDATION_UNIT: 'recommendation_unit',
  SEARCH_RECOMMENDATION: 'search_recommendation',
  SEARCH_RECOMMENDATION_PATHS: 'search_recommendation.paths_tab'
};
export const CONSUMER_SUBS_COLLECTION_ID = 3056; // Personal Plan - skills assessments
export const UB_COLLECTION_ID = 3052; // UB Pro - skills assessments
export const MEASURE_COMPETENCE_TEST_COLLECTION_ID = 3054; // Measure Competence - Test/Dev

export const PAULATEST_ORG_ID = 10996;
export const LATEST_TESTLET_GROUP_COLLECTION_QUERY = `
                  query q($input: TestletGroupCollectionInputV2!) {
                    latestTestletAttemptFromGroupCollectionV2(collectionInput: $input) {
                      group {
                        id
                        title
                        slug
                        isBeta
                        assignment {
                          id
                          dueDate
                        }
                      }
                      testletAttempt {
                        isActive
                        modified
                        results {
                          stats {
                            scaleScore
                            scalePercentile
                          }
                        }
                        testlet {
                          id
                          numQuestions
                        }
                      }
                    }
                  }`;
export const TESTLET_GROUP_COLLECTION_QUERY = ` 
            query get_collection($input: TestletGroupCollectionInputV2!) {
              testletGroupCollectionV2(collectionInput: $input) {
                groups {
                  id
                  title
                  slug
                  description
                  isBeta
                }
              }
            }`;
export const EMPTY_LAB_OBJECT = {
  id: 'labs-get-started'
};
//# sourceMappingURL=constants.js.map